import { Component, EventEmitter, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { Product } from 'src/typings';
import { ProductService } from '../product.service';

@Component({
  selector: 'app-set-new-price',
  templateUrl: './set-new-price.component.html',
  styleUrls: ['./set-new-price.component.scss']
})
export class SetNewPriceComponent {
  constructor(private productService: ProductService) {}

  saveEvent: EventEmitter<Product> = new EventEmitter();

  @Input() set product(product: Product | undefined) {
    if (!product) return;
    this._product = product;
    this.priceControl.setValue(product.retail);
  }

  get product() {
    return this._product;
  }

  loading: boolean = false;

  private _product: Product | undefined;

  priceControl = new UntypedFormControl();

  async save() {
    if (!this.product) return;
    this.loading = true;
    const newProduct = await firstValueFrom(
      this.productService.updateRetail({
        product_id: this.product.id,
        retail: this.priceControl.value
      })
    );
    this.saveEvent.emit(newProduct);
    this.loading = false;
  }
}
